import axios from "axios";
import { userEndpoint } from "src/mrkt365config";
import { appInsights } from "src/appInsights";

class EmailVerificationService {
    static async verifyEmail(token) {
      // Introduce a delay (5 seconds) to slow down automated scripts.
      await new Promise(resolve => setTimeout(resolve, 5000));
    
      // Check for the presence of a user agent.
      const userAgent = navigator && navigator.userAgent;
      if (!userAgent || userAgent.trim() === "") {
        // Track an exception if the user agent is missing or invalid.
        appInsights.trackException({
          exception: new Error("Missing or invalid user agent"),
          properties: {
            method: "verifyEmail",
            reason: "Invalid or missing navigator.userAgent"
          }
        });
        return false;
      }
    
      let verificationSuccessfull;
      try {
        // Proceed with the POST request if the user agent check passes.
        const res = await axios.post(userEndpoint + "auth/verify", { token: token });
        verificationSuccessfull = res.status === 200;
      } catch (er) {
        verificationSuccessfull = false;
        appInsights.trackException({
          exception: er,
          properties: {
            method: "verifyEmail"
          }
        });
      }
      return verificationSuccessfull;
    }



    static async sendNewToken(email) {
        var emailSentSuccessfully;
        await axios
            .post(userEndpoint + "auth/request-verify-token", { email: email })
            .then((res) => {

                if (res.status !== 202) emailSentSuccessfully = false;
                else emailSentSuccessfully = true;
            })
            .catch((er) => {
                emailSentSuccessfully = false;
                appInsights.trackException({
                    exception: er,
                    properties: {
                        method: "sendNewToken",
                    }
                })
            });

        return emailSentSuccessfully;
    }

    static async checkEmailVerification() {
        var emailIsVerified;
        await axios
            .get(userEndpoint + "users/me")
            .then((res) => {
                if (res.status === 200) emailIsVerified = true;
                else emailIsVerified = false;
            })
            .catch((er) => {
                emailIsVerified = false;
                appInsights.trackException({
                    exception: er,
                    properties: {
                        method: "checkEmailVerification",
                    }
                })
            });
        return emailIsVerified;
    }
}

export default EmailVerificationService;
